import React, { useEffect, useState } from "react";
import { Tab, Tabs, Container, Card, CardBody } from "react-bootstrap";
import SearchContainerQueue from "./CrossWalkQueue/SearchContainerQueue";
import QueueTable from "./CrossWalkQueue/QueueTable";
import SearchContainerCodes from "./ChargeCodes/SearchContainerCodes";
import ChargeCodesTable from "./ChargeCodes/ChargeCodesTable";
import SearchContainerNDCs from "./NDCs/SearchContainerNDCs";
import NDCsTable from "./NDCs/NDCsTable";
import SearchContainerCrossWalk from "./CrossWalk/SearchContainerCrossWalk";
import CrossWalkTable from "./CrossWalk/CrossWalkTable";
import SearchContainerAutoMapping from "./AutoMapping/SearchContainerAutoMapping";
import AutoMappingTable from "./AutoMapping/AutoMappingTable";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import ChargeCodeMapingTable from "./ChargeCodes/ChargeCodeMapingTable";
import NDCChargeCodeMapings from "./NDCs/NDCChargeCodeMapings";
import SearchContainerCrosswalk from "./CrossWalk/SearchContainerCrossWalk";
import useAxios from "hooks/useAxios";
import useContextService from "hooks/useContextService";
import CrosswalkingMapingTable from "./CrossWalk/CrossWalkingMapingTable";
import { cloneDeep, update } from "lodash";
import Loader from "components/Loader";
let purchaseHistoryinstialValues = {
  currentPage: 1,
  pageSize: 10,
  order: "desc",
  orderBy: "ModifiedDate",
  filters: [],
  AccumulatorID: ""

}
let MapingHistoryinstialValues = {
  currentPage: 1,
  pageSize: 10,
  order: "desc",
  orderBy: "ModifiedDate",
  filters: [],
  AccumulatorID: ""

}
const CrossWalk = (props) => {
  const API = useAxios();
  const {
    states: {
      crosswalkQueue,
      crosswalkAutomapping,
      crosswalkUnmappedcharge,
      crosswalkNdc,
      crosswalk,
    },
    setStates,
    resetStates,
  } = useContextService();
  const { queuesearch, searchTerms } = crosswalkQueue;
  const { automappingsearch } = crosswalkAutomapping;
  const { unmappedchargesearch } = crosswalkUnmappedcharge;
  const { crosswalkNdcsearch } = crosswalkNdc;
  const { crosswalksearch } = crosswalk;
  const updateStates = (all) => {
    setStates(all, all);
  };
  const [ndcDetails, setndcDetails] = useState({})
  const [ndcmapingHistoryData, setNDCMapingHistoryData] = useState([]);
  const [ndcPurchaseHistoryData, setNdcPurchaseHistoryData] = useState([]);
  const [ndcPurchaseHistoryRecords, setNdcPurchaseHistoryRecords] = useState(0);
  const [selectedndcpurchaseData, setSelectedNdcPurchaseData] = useState({})
  const [chargeCodeDetails, setChargeCodeDetails] = useState({});
  const [mapingHistoryData, setMapingHistoryData] = useState([]);
  const [chargekey, setChargekey] = useState("unmappedChargeCode");
  const [ndckey, setNdckey] = useState("unmappedndc");
  const [utilizationData, setUtilizationData] = useState([]);
  const [storedDate, setStoredDate] = useState('');
  const [utilizationDataRecords, setUtilizationDataRecords] = useState(0)
  const [selectedutilizationData, setSelectedUtilizationData] = useState({})
  const [loading, setLoading] = useState(false);
  const { orgId } = props;
  const [reset, setReset] = useState(false);
  const [reset2, setReset2] = useState(false);
  const [reset3, setReset3] = useState(false);
  const [reset4, setReset4] = useState(false);
  const [reset5, setReset5] = useState(false);

  const [key, setkey] = useState("queue");
  const [columnFilters, setColumnFilters] = useState([]);
  const [AutoMapcolumnFilters, setAutoMapColumnFilters] = useState([]);
  const [unMappedChargecolumnFilters, setUnMappedChargeColumnFilters] =
    useState([]);
  const [NdccolumnFilters, setNdcColumnFilters] = useState([]);
  const [CrosswalkcolumnFilters, setCrosswalkColumnFilters] = useState([]);
  const [searchChargeCode, setSearchChargeCode] = useState(false)
  const [searchNdcCode, setSearchNdcCode] = useState(0)

  const [queueTableData, setQueueTableData] = useState([]);
  const [autoMappingTableData, setAutoMappingTableData] = useState([]);
  const [automappingTotalrecords, setAutoMappingTotalrecords] = useState(0);
  const [queueTotalrecords, setQueueTotalrecords] = useState(0);
  const [unMappedChargeTableData, setUnMappedChargeTableData] = useState([]);
  const [unmappedChargeTotalrecords, setUnmappedChargeTotalrecords] =
    useState(0);
  const [NdcTableData, setNdcTableData] = useState([]);
  const [NdcTotalrecords, setNdcTotalrecords] = useState(0);
  const [CrosswalkTableData, setCrosswalkTableData] = useState([]);
  const [CrosswalkTotalrecords, setCrosswalkTotalrecords] = useState(0);

  const [collapseSider, setcollapseSider] = useState(false);
  const [collIcon, setCollIcon] = useState(faAngleUp);
  const [chargecodeflag, setChargeCodeflag] = useState(false);
  const [Ndcflag, setNdcflag] = useState(false);
  const [Crosswalkflag, setCrosswalkflag] = useState(false);
  const [AutoMappingflag, setAutoMappingflag] = useState(false);
  const [status, setStatus] = useState('all');
  const [ishiddenflag, setIshiddenflag] = useState(false);
  const [resetFilterFlag, SetResetFilterFlag]= useState(false);
  useEffect(() => {
    setQueueTableData([]);
    setQueueTotalrecords(0);
    setUnMappedChargeTableData([]);
    setUnmappedChargeTotalrecords(0);
    setNdcTableData([]);
    setNdcTotalrecords(0);
    setCrosswalkTableData([]);
    setCrosswalkTotalrecords(0);
    setAutoMappingTableData([]);
    setAutoMappingTotalrecords(0);
  }, [orgId]);

  const toggleSider = () => {
    setcollapseSider(!collapseSider);
    if (!collapseSider) {
      setCollIcon(faAngleDown);
    } else {
      setCollIcon(faAngleUp);
    }
  };

  const resetData = () => {
    setQueueTableData([]);
    setQueueTotalrecords(0);
    SetResetFilterFlag(true);
  };

  const onKeyChange = (k) => {
    debugger;
    if (k == 'queue') {
      resetStates('crosswalkQueue');
      setReset(!reset);
    } else if (k == 'chargeCodes') {  
      resetStates('crosswalkUnmappedcharge');
      setReset2(!reset2);
    } else if (k == 'ndcs') {
      resetStates('crosswalkNdc');
      setReset3(!reset3);
    } else if (k == 'crosswalk') {
      resetStates('crosswalk');
      setReset4(!reset4);
    } else if (k == 'autoMapping') {
      resetStates('crosswalkAutomapping');
      setReset5(!reset5);
    }
    setkey(k);
    setQueueTableData([]);
    setQueueTotalrecords(0);
    setUnMappedChargeTableData([]);
    setUnmappedChargeTotalrecords(0);
    setNdcTableData([]);
    setNdcTotalrecords(0);
    setCrosswalkTableData([]);
    setCrosswalkTotalrecords(0);
    setAutoMappingTableData([]);
    setAutoMappingTotalrecords(0);
    SetResetFilterFlag(true);
  }
  // start crosswalkQueue
  const handleQueueSearch = async (filter) => {
    const { accumulationIDs } = filter;

    const tableRes = document.querySelector(".table-responsive");
    tableRes.scrollLeft = 0;
    //search.filters = filters;
    queuesearch.AccumulatorID = accumulationIDs;
    if (key == "queue") {
      await fetchCrosswalkQueueAll(queuesearch);
    }
  };

  const refetch = (hasvalue) => {
    debugger;
    queuesearch.filters = [];
    queuesearch.currentPage = 1;
    setColumnFilters([]);
    if (hasvalue) {
      fetchCrosswalkQueueAll(queuesearch);
    }
    updateStates(queuesearch);
  };

  const fetchCrosswalkQueueAll = async (search) => {
    debugger;
    if (!orgId?.tenantID) return null;
    if (key != "queue") return null;
    if (window.selectedCoveredEntittyId == "" || window.selectedCoveredEntittyId == undefined) return null;
    setLoading(true);
    try {
      const { data } = await API.post(
        `SBTenant/${orgId.tenantID}/CrossWalk/CrosswalkQueueAll`,
        search,
        { hasDefaultURL: true }
      );
      if (data?.items?.length > 0) {
        setQueueTableData(data.items);
        setQueueTotalrecords(data.totalRecords);
        setLoading(false);
      } else {
        setQueueTableData([]);
        setQueueTotalrecords(0);
        setLoading(false);
      }
    } catch {
      setLoading(false);
    }
  };

  const onPageChangeQueue = (filter, haveColFilter) => {
    debugger;
    updateCrosswalkQueueSearch(filter);
    if (haveColFilter) {
      const filterObj = cloneDeep(queuesearch);
      filterObj.filters = [...filterObj.filters, ...filter.filters];
      
      crosswalkQueue.queuesearch = { ...crosswalkQueue.queuesearch, ...filter };
      debugger;
      fetchCrosswalkQueueAll(filterObj);
    } else {
      debugger;
      fetchCrosswalkQueueAll(filter);
      crosswalkQueue.queuesearch = { ...crosswalkQueue.queuesearch, ...filter };
    }
    updateStates(crosswalkQueue);
  };

  const updateCrosswalkQueueSearch = (filter) => {
      crosswalkQueue.queuesearch.currentPage = filter.currentPage;
      crosswalkQueue.queuesearch.pageSize = filter.pageSize;
      crosswalkQueue.queuesearch.order = filter.order;
      crosswalkQueue.queuesearch.orderBy = filter.orderBy;
  }

  const handleSearchColumnFilters = async (columnFilters) => {
    debugger
    const filterObj = cloneDeep(queuesearch);
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
      setColumnFilters(columnFilters);
    }
    debugger;
    filterObj.currentPage = 1;
    queuesearch.currentPage = 1;
    await fetchCrosswalkQueueAll(filterObj);
    updateStates(queuesearch);
  };

  //end crosswalkQueue

  // start unmappedchargeCode

  const handleunMappedChargeCodeSearch = async (filter) => {
    const { accumulationIDs } = filter;

    const tableRes = document.querySelector(".table-responsive");
    tableRes.scrollLeft = 0;
    //search.filters = filters;
    unmappedchargesearch.AccumulatorID = accumulationIDs;
    purchaseHistoryinstialValues.AccumulatorID = accumulationIDs
    if (key == "chargeCodes" && chargekey == "unmappedChargeCode") {
      await fetchUnmappedChargeAll(unmappedchargesearch);
    }
    else {
      setSearchChargeCode(true)
    }
  };
  const fetchUnmappedChargeAll = async (search) => {
    debugger;

    if (!orgId?.tenantID) return null;
    if (key != "chargeCodes" && chargekey != "unmappedChargeCode") return null;
    if (window.selectedCoveredEntittyId == "" || window.selectedCoveredEntittyId == undefined) return null;
    setLoading(true);
    try {
      const { data } = await API.post(
        `SBTenant/${orgId.tenantID}/CrossWalk/UnMappedChargeCodeAll`,
        search,
        { hasDefaultURL: true }
      );
      if (data?.items?.length > 0) {
        setUnMappedChargeTableData(data.items);
        setUnmappedChargeTotalrecords(data.totalRecords);
        setLoading(false);
      } else {
        setUnMappedChargeTableData([]);
        setUnmappedChargeTotalrecords(0);
        setLoading(false);
      }
    } catch {
      setLoading(false);
    }
  };
  const resetDataunmappecharge = () => {
    setUnMappedChargeTableData([]);
    setUnmappedChargeTotalrecords(0);
    SetResetFilterFlag(true);
  };
  const onPageChangeUnMappedCharge = (filter, haveColFilter) => {
    debugger;
    updateUnmappedChargeSearch(filter);
    if (haveColFilter) {
      const filterObj = cloneDeep(unmappedchargesearch);
      filterObj.filters = [...filterObj.filters, ...filter.filters];
    
      crosswalkUnmappedcharge.unmappedchargesearch = {
        ...crosswalkUnmappedcharge.unmappedchargesearch,
        ...filter,
      };
      debugger;
      fetchUnmappedChargeAll(filterObj);
    } else {
      debugger;
      fetchUnmappedChargeAll(filter);
      crosswalkUnmappedcharge.unmappedchargesearch = {
        ...crosswalkUnmappedcharge.unmappedchargesearch,
        ...filter,
      };
    }
    updateStates(crosswalkUnmappedcharge);
  };

 const updateUnmappedChargeSearch = (filter) => {
      crosswalkUnmappedcharge.unmappedchargesearch.currentPage = filter.currentPage;
      crosswalkUnmappedcharge.unmappedchargesearch.pageSize = filter.pageSize;
      crosswalkUnmappedcharge.unmappedchargesearch.order= filter.order;
      crosswalkUnmappedcharge.unmappedchargesearch.orderBy= filter.orderBy; 
 }
  const handleSearchUnMappedChargeColumnFilters = async (columnFilters) => {
    debugger;
    const filterObj = cloneDeep(unmappedchargesearch);
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
      setUnMappedChargeColumnFilters(columnFilters);
    }
    debugger;
    filterObj.currentPage = 1;
    unmappedchargesearch.currentPage = 1;
    await fetchUnmappedChargeAll(filterObj);
  };
  const refetchunMappedcharge = (hasvalue) => {
    debugger;
    unmappedchargesearch.filters = [];
    unmappedchargesearch.currentPage = 1;
    setUnMappedChargeColumnFilters([]);
    if (hasvalue) {
      fetchUnmappedChargeAll(unmappedchargesearch);
    }
  };
  //end unmappedchargeCode

  //  start-automapping
  const handelAutoMapping = async (filter) => {
    const { accumulationIDs } = filter;

    const tableRes = document.querySelector(".table-responsive");
    tableRes.scrollLeft = 0;
    //search.filters = filters;
    automappingsearch.AccumulatorID = accumulationIDs;
    if (key == "autoMapping") {
      await fetchCrossAutoMapping(automappingsearch);
    }
  };
  const AutoMappingrefetc = (hasvalue) => {
    debugger
    automappingsearch.filters = [];
    automappingsearch.currentPage = 1;
    setAutoMapColumnFilters([]);
    if (hasvalue) {
      fetchCrossAutoMapping(automappingsearch);
    }
  };
  const fetchCrossAutoMapping = async (search) => {
    debugger;

    if (!orgId?.tenantID) return null;
    if (key != "autoMapping") return null;
    if (window.selectedCoveredEntittyId == "" || window.selectedCoveredEntittyId == undefined) return null;
    setLoading(true);
    try {
      const { data } = await API.post(
        `SBTenant/${orgId.tenantID}/CrossWalk/AutoMappingAll`,
        search,
        { hasDefaultURL: true }
      );
      if (data?.items?.length > 0) {
        setAutoMappingTableData(data.items);
        setAutoMappingTotalrecords(data.totalRecords);
        setLoading(false);
      } else {
        setAutoMappingTableData([]);
        setAutoMappingTotalrecords(0);
        setLoading(false);
      }
    } catch {
      setLoading(false);
    }
  };
  const resetDataAutoMapping = () => {
    setAutoMappingTableData([]);
    setAutoMappingTotalrecords(0);
    SetResetFilterFlag(true);
  };
  const onPageChangeAutoMapping = (filter, haveColFilter) => {
    debugger;
    updateCrossAutoMappingSearch(filter);
    if (haveColFilter) {
      const filterObj = cloneDeep(automappingsearch);
      filterObj.filters = [...filterObj.filters, ...filter.filters];
      crosswalkAutomapping.automappingsearch = {
        ...crosswalkAutomapping.automappingsearch,
        ...filter,
      };
      debugger;
      fetchCrossAutoMapping(filterObj);
    } else {
      debugger;
      fetchCrossAutoMapping(filter);
      crosswalkAutomapping.automappingsearch = {
        ...crosswalkAutomapping.automappingsearch,
        ...filter,
      };
    }
    updateStates(crosswalkAutomapping);
  };
 const updateCrossAutoMappingSearch = (filter) => {
      crosswalkAutomapping.automappingsearch.currentPage = filter.currentPage;
      crosswalkAutomapping.automappingsearch.pageSize = filter.pageSize;
      crosswalkAutomapping.automappingsearch.order = filter.order;
      crosswalkAutomapping.automappingsearch.orderBy = filter.orderBy;
  }

  const handleSearchAutoMappingColumnFilters = async (columnFilters) => {
    const filterObj = cloneDeep(automappingsearch);
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
      setAutoMapColumnFilters(columnFilters);
    }
    debugger;
    filterObj.currentPage = 1;
    automappingsearch.currentPage = 1;
    await fetchCrossAutoMapping(filterObj);
  };
  // end-automapping

  //  ndc starting
  const handelNdcCrosswalk = async (filter) => {
    const { accumulationIDs } = filter;

    const tableRes = document.querySelector(".table-responsive");
    MapingHistoryinstialValues.AccumulatorID = accumulationIDs

    tableRes.scrollLeft = 0;
    //search.filters = filters;
    crosswalkNdcsearch.AccumulatorID = accumulationIDs;
    if (key == "ndcs" && ndckey == "unmappedndc") {
      await fetchCrosswalkNdc(crosswalkNdcsearch);
    }
    else {
       const rand = Math.floor(Math.random() * 100) + 1;
      setSearchNdcCode(rand)
    }
  };
  const Ndcrefetc = (hasvalue) => {
    crosswalkNdcsearch.filters = [];
    crosswalkNdcsearch.currentPage = 1;
    setNdcColumnFilters([]);
    if (hasvalue) {
      fetchCrosswalkNdc(crosswalkNdcsearch);
    }
  };
  const fetchCrosswalkNdc = async (search) => {
    debugger;

    if (!orgId?.tenantID) return null;
    if (key != "ndcs" && ndckey != "unmappedndc") return null;
    if (window.selectedCoveredEntittyId == "" || window.selectedCoveredEntittyId == undefined) return null;
    setLoading(true);

    try {
      const { data } = await API.post(
        `SBTenant/${orgId.tenantID}/CrossWalk/UnMappedNdcAll`,
        search,
        { hasDefaultURL: true }
      );
      if (data?.items?.length > 0) {
        setNdcTableData(data.items);
        setNdcTotalrecords(data.totalRecords);
        setLoading(false);
      } else {
        setNdcTableData([]);
        setNdcTotalrecords(0);
        setLoading(false);
      }
    } catch {
      setLoading(false);
    }
  };
  const resetDataNdc = () => {
    setNdcTableData([]);
    setNdcTotalrecords(0);
    SetResetFilterFlag(true);
  };
  const onPageChangeNdc = (filter, haveColFilter) => {
    debugger;
    updateCrossWalkNdcSearch(filter);
    if (haveColFilter) {
      const filterObj = cloneDeep(crosswalkNdcsearch);
      filterObj.filters = [...filterObj.filters, ...filter.filters];
      
      crosswalkNdc.crosswalkNdcsearch = {
        ...crosswalkNdc.crosswalkNdcsearch,
        ...filter,
      };
      debugger;
      fetchCrosswalkNdc(filterObj);
    } else {
      debugger;
      fetchCrosswalkNdc(filter);
      crosswalkNdc.crosswalkNdcsearch = {
        ...crosswalkNdc.crosswalkNdcsearch,
        ...filter,
      };
    }
    updateStates(crosswalkNdc);
  };

  const updateCrossWalkNdcSearch = (filter) => {
      crosswalkNdc.crosswalkNdcsearch.currentPage = filter.currentPage;
      crosswalkNdc.crosswalkNdcsearch.pageSize = filter.pageSize;
      crosswalkNdc.crosswalkNdcsearch.order = filter.order;
      crosswalkNdc.crosswalkNdcsearch.orderBy = filter.orderBy;
  }

  const handleSearchNdcColumnFilters = async (columnFilters) => {
    const filterObj = cloneDeep(crosswalkNdcsearch);
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
      setNdcColumnFilters(columnFilters);
    }
    debugger;
    filterObj.currentPage = 1;
    crosswalkNdcsearch.currentPage = 1;
    await fetchCrosswalkNdc(filterObj);
  };

  // ndc ending

  // crosswalk start
  const handelCrosswalk = async (filter) => {
    const { accumulationIDs } = filter;

    const tableRes = document.querySelector(".table-responsive");
    tableRes.scrollLeft = 0;
    //search.filters = filters;
    crosswalksearch.AccumulatorID = accumulationIDs;
    if (key == "crosswalk") {
      await fetchCrosswalk(crosswalksearch);
    }
  };
  const Crosswalkrefetc = (hasvalue) => {
    debugger
    crosswalksearch.filters = [];
    crosswalksearch.currentPage = 1;
    setCrosswalkColumnFilters([]);
    if (hasvalue) {
      fetchCrosswalk(crosswalksearch);
    }
  };
  const fetchCrosswalk = async (search) => {
    debugger;

    if (!orgId?.tenantID) return null;
    if (key != "crosswalk") return null;
    if (window.selectedCoveredEntittyId == "" || window.selectedCoveredEntittyId == undefined) return null;
    setLoading(true);

    try {
      const { data } = await API.post(
        `SBTenant/${orgId.tenantID}/CrossWalk/Crosswalks/${status}`,
        search,
        { hasDefaultURL: true }
      );
      if (data?.items?.length > 0) {
        setCrosswalkTableData(data.items);
        setCrosswalkTotalrecords(data.totalRecords);
        setLoading(false);
      } else {
        setCrosswalkTableData([]);
        setCrosswalkTotalrecords(0);
        setLoading(false);
      }
    } catch {
      setLoading(false);
    }
  };
  const resetDataCrosswalk = () => {
    setCrosswalkTableData([]);
    setCrosswalkTotalrecords(0);
    SetResetFilterFlag(true);
  };
  const onPageChangeCrosswalk = (filter, haveColFilter) => {
    debugger;
     updatecrosswalksearch(filter);
    if (haveColFilter) {
      const filterObj = cloneDeep(crosswalksearch);
      filterObj.filters = [...filterObj.filters, ...filter.filters];
      crosswalk.crosswalksearch = { ...crosswalk.crosswalksearch, ...filter };
      debugger;
      fetchCrosswalk(filterObj);
    } else {
      debugger;
      fetchCrosswalk(filter);
      crosswalk.crosswalksearch = { ...crosswalk.crosswalksearch, ...filter };
    }
    updateStates(crosswalk);
  };

  const updatecrosswalksearch = (filter) => {
     crosswalk.crosswalksearch.currentPage = filter.currentPage;
      crosswalk.crosswalksearch.pageSize = filter.pageSize;
      crosswalk.crosswalksearch.order = filter.order;
      crosswalk.crosswalksearch.orderBy = filter.orderBy;
  }

  const handleSearchCrosswalkColumnFilters = async (columnFilters) => {
    const filterObj = cloneDeep(crosswalksearch);
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
      setCrosswalkColumnFilters(columnFilters);
    }
    debugger;
    filterObj.currentPage = 1;
    crosswalksearch.currentPage = 1;
    await fetchCrosswalk(filterObj);
  };

  // end crosswalk

  return (
    <>
      <div>
        {loading && <Loader opacity={0.01} />}
        <Container fluid className="width_info bin_info">
          <div
            className={
              collapseSider ||
                chargecodeflag ||
                Ndcflag ||
                Crosswalkflag ||
                AutoMappingflag
                ? "mb-0"
                : "mb-3"
            }
          >
            <Card
              hidden={
                collapseSider ||
                chargecodeflag ||
                Ndcflag ||
                Crosswalkflag ||
                AutoMappingflag
              }
              className="border-0 shadow-top"
            >
              <CardBody className="section-devider-border">
                <Tabs
                  id="controlled-tab-example"
                  activeKey={key}
                  onSelect={(k) => onKeyChange(k)}
                  className="mb-3"
                >
                  <Tab eventKey="queue" title="Crosswalk Queue">
                    <SearchContainerQueue
                      onSearch={handleQueueSearch}
                      orgId={orgId}
                      resetData={resetData}
                      key={key}
                      setLoading={setLoading}
                      reset = {reset}
                    />
                  </Tab>
                  <Tab eventKey="chargeCodes" title="Charge Codes">
                    <SearchContainerCodes
                      onSearch={handleunMappedChargeCodeSearch}
                      resetData={resetDataunmappecharge}
                      orgId={orgId}
                      key={key}
                      setLoading={setLoading}
                      reset = {reset2}
                      setStoredDate={setStoredDate}
                      SetResetFilterFlag={SetResetFilterFlag}
                    />
                  </Tab>
                  <Tab eventKey="ndcs" title="NDCs">
                    <SearchContainerNDCs
                      orgId={orgId}
                      onSearch={handelNdcCrosswalk}
                      resetData={resetDataNdc}
                      key={key}
                      setLoading={setLoading}
                      reset = {reset3}
                      setStoredDate={setStoredDate}

                    />
                  </Tab>
                  <Tab eventKey="crosswalk" title="Crosswalk">
                    <SearchContainerCrosswalk
                      orgId={orgId}
                      onSearch={handelCrosswalk}
                      resetData={resetDataCrosswalk}
                      key={key}
                      setLoading={setLoading}
                      setStatus={setStatus}
                      status={status}
                      reset={reset4}
                      setStoredDate={setStoredDate}
                    />
                  </Tab>
                  <Tab eventKey="autoMapping" title="Automapping">
                    <SearchContainerAutoMapping
                      orgId={orgId}
                      onSearch={handelAutoMapping}
                      resetData={resetDataAutoMapping}
                      key={key}
                      setLoading={setLoading}
                      reset = {reset5}
                    />
                  </Tab>
                </Tabs>
              </CardBody>
            </Card>
          </div>
          <Card
            className="border-0 shadow-top"
            hidden={
              chargecodeflag || Ndcflag || Crosswalkflag || AutoMappingflag
            }
          >
            <CardBody className="section-devider-border">
              {key == "queue" && (
                <QueueTable
                  columnFilters={columnFilters}
                  loading={loading}
                  toggleSider={toggleSider}
                  collapseSider={collapseSider}
                  queueTableData={queueTableData}
                  setQueueTableData={setQueueTableData}
                  queueTotalrecords={queueTotalrecords}
                  onSearchColumnFilters={handleSearchColumnFilters}
                  orgId={orgId}
                  setLoading={setLoading}
                  onPageChange={onPageChangeQueue}
                  refetch={refetch}
                  queuesearch={queuesearch}
                  key={key}
                  setIshiddenflag={setIshiddenflag}
                  ishiddenflag={ishiddenflag}
                  SetResetFilterFlag={SetResetFilterFlag}
                  resetFilterFlag={resetFilterFlag}
                />
              )}
              {key == "chargeCodes" && (
                <ChargeCodesTable
                  setUnMappedChargeTableData={setUnMappedChargeTableData}
                  unMappedChargeTableData={unMappedChargeTableData}
                  unmappedChargeTotalrecords={unmappedChargeTotalrecords}
                  toggleSider={toggleSider}
                  collapseSider={collapseSider}
                  chargecodeflag={chargecodeflag}
                  setChargeCodeflag={setChargeCodeflag}
                  unMappedChargecolumnFilters={unMappedChargecolumnFilters}
                  onPageChangeUnMappedCharge={onPageChangeUnMappedCharge}
                  handleSearchUnMappedChargeColumnFilters={handleSearchUnMappedChargeColumnFilters}
                  loading={loading}
                  orgId={orgId}
                  setLoading={setLoading}
                  refetchunMappedcharge={refetchunMappedcharge}
                  unmappedchargesearch={unmappedchargesearch}
                  mapingHistoryData={mapingHistoryData}
                  setMapingHistoryData={setMapingHistoryData}
                  utilizationData={utilizationData}
                  setUtilizationData={setUtilizationData}
                  setChargeCodeDetails={setChargeCodeDetails}
                  chargekey={chargekey}
                  setChargekey={setChargekey}
                  utilizationDataRecords={utilizationDataRecords}
                  setUtilizationDataRecords={setUtilizationDataRecords}
                  purchaseHistoryinstialValues={purchaseHistoryinstialValues}
                  selectedutilizationData={selectedutilizationData}
                  setSelectedUtilizationData={setSelectedUtilizationData}
                  searchChargeCode={searchChargeCode}
                  setSearchChargeCode={setSearchChargeCode}
                  reset2 = {reset2}
                  SetResetFilterFlag={SetResetFilterFlag}
                  resetFilterFlag={resetFilterFlag}
                />
              )}
              {key == "ndcs" && (
                <NDCsTable
                  toggleSider={toggleSider}
                  collapseSider={collapseSider}
                  Ndcflag={Ndcflag}
                  setNdcflag={setNdcflag}
                  NdccolumnFilters={NdccolumnFilters}
                  onPageChangeNdc={onPageChangeNdc}
                  handleSearchNdcColumnFilters={handleSearchNdcColumnFilters}
                  loading={loading}
                  setLoading={setLoading}
                  crosswalkNdcsearch={crosswalkNdcsearch}
                  setNdcTableData={setNdcTableData}
                  NdcTableData={NdcTableData}
                  NdcTotalrecords={NdcTotalrecords}
                  Ndcrefetc={Ndcrefetc}
                  ndckey={ndckey}
                  setNdckey={setNdckey}
                  setNdcPurchaseHistoryData={setNdcPurchaseHistoryData}
                  setNDCMapingHistoryData={setNDCMapingHistoryData}
                  orgId={orgId}
                  setndcDetails={setndcDetails}
                  ndcPurchaseHistoryRecords={ndcPurchaseHistoryRecords}
                  setNdcPurchaseHistoryRecords={setNdcPurchaseHistoryRecords}
                  selectedndcpurchaseData={selectedndcpurchaseData}
                  setSelectedNdcPurchaseData={setSelectedNdcPurchaseData}
                  MapingHistoryinstialValues={MapingHistoryinstialValues}
                  searchNdcCode={searchNdcCode}
                  setSearchChargeCode={setSearchChargeCode}
                  SetResetFilterFlag={SetResetFilterFlag}
                  resetFilterFlag={resetFilterFlag}

                />
              )}
              {key == "crosswalk" && (
                <CrossWalkTable
                  toggleSider={toggleSider}
                  collapseSider={collapseSider}
                  chargecodeflag={Crosswalkflag}
                  setChargeCodeflag={setCrosswalkflag}
                  CrosswalkTableData={CrosswalkTableData}
                  CrosswalkTotalrecords={CrosswalkTotalrecords}
                  setCrosswalkTableData={setCrosswalkTableData}
                  loading={loading}
                  setLoading={setLoading}
                  refetch={Crosswalkrefetc}
                  crosswalksearch={crosswalksearch}
                  CrosswalkcolumnFilters={CrosswalkcolumnFilters}
                  onPageChange={onPageChangeCrosswalk}
                  onSearchColumnFilters={handleSearchCrosswalkColumnFilters}
                  chargeCodeDetails={chargeCodeDetails}
                  setChargeCodeDetails={setChargeCodeDetails}
                  mapingHistoryData={mapingHistoryData}
                  setMapingHistoryData={setMapingHistoryData}
                  setIshiddenflag={setIshiddenflag}
                  ishiddenflag={ishiddenflag}
                  orgId={orgId}
                  status={status}
                  SetResetFilterFlag={SetResetFilterFlag}
                  resetFilterFlag={resetFilterFlag}
                  storedDate={storedDate}
                />
              )}
              {key == "autoMapping" && (
                <AutoMappingTable
                  toggleSider={toggleSider}
                  collapseSider={collapseSider}
                  AutoMappingflag={AutoMappingflag}
                  setAutoMappingflag={setAutoMappingflag}
                  autoMappingTableData={autoMappingTableData}
                  setAutoMappingTableData={setAutoMappingTableData}
                  automappingTotalrecords={automappingTotalrecords}
                  loading={loading}
                  setLoading={setLoading}
                  refetch={AutoMappingrefetc}
                  automappingsearch={automappingsearch}
                  AutoMapcolumnFilters={AutoMapcolumnFilters}
                  onPageChange={onPageChangeAutoMapping}
                  onSearchColumnFilters={handleSearchAutoMappingColumnFilters}
                  orgId={orgId}
                  setAutoMappingTotalrecords={setAutoMappingTotalrecords}
                  SetResetFilterFlag={SetResetFilterFlag}
                  resetFilterFlag={resetFilterFlag}
                />
              )}
            </CardBody>
          </Card>
          {chargecodeflag == true && (
            <>
              <ChargeCodeMapingTable
                toggleSider={toggleSider}
                collapseSider={collapseSider}
                chargecodeflag={chargecodeflag}
                setChargeCodeflag={setChargeCodeflag}
                mapingHistoryData={mapingHistoryData}
                setMapingHistoryData={setMapingHistoryData}
                utilizationData={utilizationData}
                setUtilizationData={setUtilizationData}
                utilizationDataRecords={utilizationDataRecords}
                setUtilizationDataRecords={setUtilizationDataRecords}
                loading={loading}
                orgId={orgId}
                selectedutilizationData={selectedutilizationData}
                setSelectedUtilizationData={setSelectedUtilizationData}
                setLoading={setLoading}
                chargeCodeDetails={chargeCodeDetails}
                unmappedchargesearch={unmappedchargesearch}
                tabkey={key}
                purchaseHistoryinstialValues={purchaseHistoryinstialValues}
                hidden={false}
                ishiddenflag={ishiddenflag}
                setIshiddenflag={setIshiddenflag}
                refetchunMappedcharge={refetchunMappedcharge}
                storedDate={storedDate}

              />
            </>
          )}
          {Ndcflag == true && (
            <>
              <NDCChargeCodeMapings
                loading={loading}
                orgId={orgId}
                setLoading={setLoading}
                toggleSider={toggleSider}
                collapseSider={collapseSider}
                Ndcflag={Ndcflag}
                setNdcflag={setNdcflag}
                ndcDetails={ndcDetails}
                crosswalkNdcsearch={crosswalkNdcsearch}
                setNdcPurchaseHistoryData={setNdcPurchaseHistoryData}
                setNDCMapingHistoryData={setNDCMapingHistoryData}
                setndcDetails={setndcDetails}
                ndcmapingHistoryData={ndcmapingHistoryData}
                ndcPurchaseHistoryData={ndcPurchaseHistoryData}
                ndcPurchaseHistoryRecords={ndcPurchaseHistoryRecords}
                setNdcPurchaseHistoryRecords={setNdcPurchaseHistoryRecords}
                selectedndcpurchaseData={selectedndcpurchaseData}
                setSelectedNdcPurchaseData={setSelectedNdcPurchaseData}
                MapingHistoryinstialValues={MapingHistoryinstialValues}
                setIshiddenflag={setIshiddenflag}
                ishiddenflag={ishiddenflag}
                Ndcrefetc={Ndcrefetc}
                storedDate={storedDate}
              />
            </>
          )}
          {Crosswalkflag == true && (
            <>
              <ChargeCodeMapingTable
                toggleSider={toggleSider}
                collapseSider={collapseSider}
                chargecodeflag={Crosswalkflag}
                setChargeCodeflag={setCrosswalkflag}
                mapingHistoryData={mapingHistoryData}
                setMapingHistoryData={setMapingHistoryData}
                utilizationData={utilizationData}
                setUtilizationData={setUtilizationData}
                loading={loading}
                orgId={orgId}
                setLoading={setLoading}
                chargeCodeDetails={chargeCodeDetails}
                hidden={true}
                Crosswalkrefetc={Crosswalkrefetc}
                crosswalksearch={crosswalksearch}
                tabkey={key}
                ishiddenflag={ishiddenflag}
                setIshiddenflag={setIshiddenflag}
                storedDate={storedDate}
              />
            </>
          )}
          {AutoMappingflag == true && <></>}
        </Container>
      </div>
    </>
  );
};

export default CrossWalk;
